module.exports = __webpack_public_path__ + "assets/ic-coinidol.0a964ea7.svg";